<template>
	<div>
		<div v-if="loadingCobrosProgramados">
			<preloader></preloader>
		</div>
		<div class="row">
			<div class="col-md-2">
				<button class="btn btn-success my-3 btn-sm" v-on:click="addCobroProgramado" v-if="roleUser() != 'V' && !disabledValue">
					<i class="material-icons">add</i>
				</button>
				<button class="btn btn-primary my-3 btn-sm" v-on:click="getCobrosProgramados">
					<i class="material-icons">refresh</i>
				</button>
			</div>
		</div>
		<div class="table-responsive" v-if="cobrosFiltered.length>0">
			<table v-bind:class="{'table table-borderless table-hover table-striped':true, 'table-sm':compacta}">
	            <thead>
	                <tr class="border-bottom">
	                	<th>
	                		<catalogo-endosos v-model="filterEndoso" :poliza="this.codigo" v-if="!loadingCobrosProgramados"></catalogo-endosos>
	                	</th>
	                    <th>Código</th>
	                    <th>Fecha</th>
	                    <th>Monto Neto</th>
	                    <th>Monto Programado</th>
	                    <th>Saldo</th>
	                    <th>Requerimiento</th>
	                    <th width="230">
	                    	<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="compactaProgramados" v-model="compacta">
								<label class="custom-control-label" for="compactaProgramados">Compacta</label>
							</div>
	                    </th>
	                </tr>
	                <tr>
						<td colspan="8" class="p-1">
							<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
								Cobros programados ({{cobrosFiltered.length}})
							</div>
						</td>
					</tr>
	            </thead>
	            <tbody>
	            	<tr v-for="cobro in cobrosFiltered" :class="{'cursor-pointer':true, 'bg-gray-light text-muted':cobro.SALDO_COBRO==0,'opacity-70':cobro.SALDO_COBRO<=0,'table-danger':cobro.SALDO_COBRO<0}" v-on:click="showCobroProgramado(cobro)">
	            		<th>{{cobro.CODIGO_DOCUMENTO}}</th>
	                   	<th>{{cobro.CODIGO_COBRO}}</th>
	                   	<td class="text-center">{{cobro.FECHA_PROGRAMADO}}</td>
						<td class="text-right">{{money(cobro.MONTO_NETO, true)}}</td>
	                   	<td class="text-right">
	                   		{{money(cobro.MONTO_PROGRAMADO, true)}}
	                   	</td>
	                   	<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.SALDO_COBRO<0,'table-danger pulse': validateFecha(cobro.FECHA_PROGRAMADO) && cobro.SALDO_COBRO>0}">{{money(cobro.SALDO_COBRO, true)}}</td>
						<td>{{cobro.REQUERIMIENTO}}</td>
	                   	<td>
	                   		<div class="btn-group text-right table-hover-options">
	                   			<a
								href="#"
								class="text-muted ml-2 p-1"
								v-tooltip="'Recibo provisional'"
								v-if="roleUser() != 'V'"
								v-on:click.prevent.stop="reciboProvisional(cobro)">
									<i class="material-icons">receipt</i>
								</a>
	                   			<a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Editar Cobro'" 
		                        	v-on:click.prevent.stop="editCobroProgramado(cobro)"
		                        	v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">edit</i>
		                        </a>
		                        <a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Eliminar Cobro'" 
		                        	v-on:click.prevent.stop="deleteCobroProgramado(cobro)" v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">delete</i>
		                        </a>
		                        <a 
		                        	href="#" 
		                        	v-bind:class="{'ml-2 p-1':true,'bg-danger text-white pulse':validateFecha(cobro.FECHA_PROGRAMADO) && cobro.SALDO_COBRO>0,'text-muted':!validateFecha(cobro.FECHA_PROGRAMADO) && cobro.SALDO_COBRO<=0}"
		                        	v-tooltip="'Agregar Cobro Realizado'" 
		                        	v-on:click.prevent.stop="addCobroRealizado(cobro)"
		                        	v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">monetization_on</i>
		                        </a>
	                   		</div>
	                   	</td>
	                </tr>
	            </tbody>
	            <tfoot>
	                <tr>
	                	<th colspan="3" class="text-right">Totales</th>
	                	<th class="text-right">
	                		{{MontoNetoAcumulado}}
	                	</th>
	                	<th class="text-right">
	                		{{MontoProgramadoAcumulado}}
	                	</th>
	                	<th class="text-right">
	                		{{SaldoAcumulado}}
	                	</th>
	                	<td colspan="2"></td>
	                </tr>
	            </tfoot>
	        </table>
	    </div>
	    <div v-else>
	    	<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a los cobros programados.">
            </empty>
	    </div>

	    <div class="modal fade" id="modalCobroProgramado" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalProgramado=='create'">
			        		Registrar Cobro Programado
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalProgramado=='edit'">
			        		Actualizar Cobro Programado
			        	</h5>
		        		<div class="float-right" v-if="modalProgramado=='edit' && programado.correlativo == 1">
		    				<div class="custom-control custom-checkbox">
								<input type="checkbox" class="custom-control-input" id="replicarDatos" v-model="programado.replicar">
							 	<label class="custom-control-label" for="replicarDatos">Realizar cambios a los demás cobros</label>
							</div>
							<div v-if="errors && errors.replicar" class="text-danger">
		                        {{ errors.replicar[0] }}
		                    </div>
		    			</div>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalProgramado=='show'">
			        		Cobro Programado {{programado.correlativo}}
			        	</h5>
			    	</div>
			    	<div class="modal-body py-0">
			    		<div v-if="modalProgramado=='show'">
				    		<ul class="nav nav-tabs" id="cobroProgramado" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" id="info-tab" data-toggle="tab" href="#info" role="tab" aria-controls="info" aria-selected="true">
										Información
									</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
										Auditoría
									</a>
								</li>
							</ul>

							<div class="tab-content" id="cobroProgramadoContent">
	  							<div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="info-tab">
	  								<div class="form-row">
						    			<div class="col-md-6 form-group">
						    				<label>Endoso:</label>
						    				<catalogo-endosos
						    					:poliza="codigo"
						    					v-model="programado.endoso"
						    					v-if="!loadingCobrosProgramados"
						    					disabled>
						    				</catalogo-endosos>
						    			</div>

						    			<div class="col-md-6 form-group">
						    				<label>
						    					Fecha:
						    				</label>
						    				<div>
						    					{{programado.fecha}}
						    				</div>
						    			</div>

						    			<div class="col-md-6 form-group">
						    				<label>
						    					Monto Programado:
						    				</label>
						    				<div>
						    					{{money(programado.monto, true)}}
						    				</div>
						    			</div>

						    			<div class="col-md-6 form-group">
						    				<label>
						    					Saldo:
						    				</label>
						    				<div>
						    					{{money(programado.saldo, true)}}
						    				</div>
						    			</div>

						    			<div class="col-md-6 form-group">
						    				<label>
						    					Requerimiento:
						    				</label>
						    				<div>
						    					{{programado.requerimiento}}
						    				</div>
						    			</div>

						    			<div class="col-md-6 form-group">
						    				<label>
						    					Monto Neto:
						    				</label>
						    				<div>
						    					{{money(programado.monto_neto, true)}}
						    				</div>
						    			</div>
						    		</div>
	  							</div>
	  							<div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
	  								<div class="row py-3">
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Creado Por'">
													<i class="material-icons">person_add</i>
												</div>
												<div class="media-body">
													<label>Creado Por:</label>
													<p class="m-0">
														{{programado.creado_por.codigo}} - {{programado.creado_por.nombre}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Actualizado Por'">
													<i class="material-icons">person_outline</i>
												</div>
												<div class="media-body">
													<label>Actualizado Por:</label>
													<p class="m-0">
														{{programado.actualizado_por.codigo}} - {{programado.actualizado_por.nombre}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Fecha Creación'">
													<i class="material-icons">access_time</i>
												</div>
												<div class="media-body">
													<label>Fecha Creación:</label>
													<p class="m-0">
														{{programado.fecha_creacion}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Fecha Actualización'">
													<i class="material-icons">update</i>
												</div>
												<div class="media-body">
													<label>Fecha Actualización:</label>
													<p class="m-0">
														{{programado.fecha_actualizacion}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Creado Desde'">
													<i class="material-icons">add_location</i>
												</div>
												<div class="media-body">
													<label>Creado Desde:</label>
													<p class="m-0">
														{{programado.creado_desde}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Actualizado Desde'">
													<i class="material-icons">edit_location</i>
												</div>
												<div class="media-body">
													<label>Actualizado Desde:</label>
													<p class="m-0">
														{{programado.actualizado_desde}}
													</p>
												</div>
											</div>
										</div>
									</div>
	  							</div>
							</div>
			    		</div>

	    				<div class="form-row" v-else>
			    			<div class="col-md-6 form-group">
			    				<label>Endoso:</label>
			    				<catalogo-endosos
			    					:poliza="codigo"
			    					v-model="programado.endoso"
			    					v-if="!loadingCobrosProgramados">
			    				</catalogo-endosos>
			    				<div v-if="errors && errors.endoso" class="text-danger">
			                        {{ errors.endoso[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-6 form-group">
			    				<label>
			    					Fecha:
			    				</label>
			    				<date-picker
			    					class="form-control form-control-sm"
			    					v-model="programado.fecha">
			    				</date-picker>
			    				<div v-if="errors && errors.fecha" class="text-danger">
			                        {{ errors.fecha[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-4 form-group">
			    				<label>
			    					Monto Programado:
			    				</label>
			    				<decimal
			    					class="form-control form-control-sm"
			    					v-model="programado.monto">
			    				</decimal>
			    				<div v-if="errors && errors.monto" class="text-danger">
			                        {{ errors.monto[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-4 form-group">
			    				<label>
			    					Saldo:
			    				</label>
			    				<decimal
			    					class="form-control form-control-sm"
			    					v-model="programado.saldo">
			    				</decimal>
			    				<div v-if="errors && errors.saldo" class="text-danger">
			                        {{ errors.saldo[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-4 form-group">
			    				<label>
			    					Monto Neto:
			    				</label>
			    				<decimal
			    					class="form-control form-control-sm"
			    					v-model="programado.monto_neto">
			    				</decimal>
			    				<div v-if="errors && errors.monto_neto" class="text-danger">
			                        {{ errors.monto_neto[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					Requerimiento:
			    				</label>
			    				<input
			    					class="form-control form-control-sm"
			    					v-model="programado.requerimiento"
			    					maxLength="30">
			    				<div v-if="errors && errors.requerimiento" class="text-danger">
			                        {{ errors.requerimiento[0] }}
			                    </div>
			    			</div>
			    		</div>
			    	</div>
			    	<div class="modal-footer">
			    		<button 
			    			type="button" 
			    			class="btn btn-secondary" 
			    			:disabled="loadingStoreProgramado"
			    			v-on:click.prevent="closeModalCobroProgramado">
			    			Cancelar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingStoreProgramado" 
			    			v-if="modalProgramado=='create' && roleUser() != 'V' && !disabledValue"
			    			v-on:click.prevent="storeCobroProgramado">
			    			Crear
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingStoreProgramado" 
			    			v-if="modalProgramado=='edit' && roleUser() != 'V' && !disabledValue"
			    			v-on:click.prevent="updateCobroProgramado">
			    			Actualizar
			    		</button>
			    	</div>
			    </div>
			</div>
		</div>

		<div class="modal fade" id="modalCobroProgramadoEnviarRealizado" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel">
			        		Agregar Cobro Realizado
			        	</h5>
			    	</div>
			    	<div class="modal-body">
	    				<div class="form-row">
			    			<div class="col-md-12 form-group">
			    				<label>
			    					Fecha de pago:
			    				</label>
			    				<date-picker
			    					class="form-control form-control-sm"
			    					v-model="realizado.fecha_pago">
			    				</date-picker>
			    				<div v-if="errors && errors.fecha_pago" class="text-danger">
			                        {{ errors.fecha_pago[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>Canal de Pago:</label>
			    				<catalogo-formas-pagos v-model="realizado.medio_pago">
			    				</catalogo-formas-pagos>
			    				<div v-if="errors && errors.medio_pago" class="text-danger">
			                        {{ errors.medio_pago[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					Monto Cobrado:
			    				</label>
			    				<decimal
			    					class="form-control form-control-sm"
			    					v-model="realizado.monto">
			    				</decimal>
			    				<div v-if="errors && errors.monto" class="text-danger">
			                        {{ errors.monto[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					Número Factura:
			    				</label>
			    				<integer
			    					class="form-control form-control-sm"
			    					v-model="realizado.factura"
			    					min="0">
			    				</integer>
			    				<div v-if="errors && errors.factura" class="text-danger">
			                        {{ errors.factura[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					Observaciones:
			    				</label>
			    				<textarea
			    					class="form-control form-control-sm"
			    					v-model="realizado.observaciones"
			    					maxLength="50">
			    				</textarea>
			    				<div v-if="errors && errors.observaciones" class="text-danger">
			                        {{ errors.observaciones[0] }}
			                    </div>
			    			</div>
			    		</div>
			    	</div>
			    	<div class="modal-footer">
			    		<button 
			    			type="button" 
			    			class="btn btn-secondary" 
			    			:disabled="loadingStoreRealizado"
			    			v-on:click="closeModalCobroRealizado"
			    			>
			    			Cancelar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingStoreRealizado" 
			    			v-on:click.prevent="storeCobroRealizado"
			    			v-if="roleUser() != 'V' && !disabledValue">
			    			Agregar
			    		</button>
			    	</div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['poliza', 'disabled'],

		mounted(){
			this.codigo = this.poliza;
			if (this.codigo) {
        		this.getCobrosProgramados();
			}

			var vm = this;
			$.fn.getCobrosProgramados = function (options) {
				vm.filterEndoso = ''
				vm.getCobrosProgramados();
			};
		},

		data(){
			return {
				codigo: '',
				cobros: [],

				filterEndoso: '',

				loadingCobrosProgramados: false,
				loadingCobrosRealizados: false,
				loadingStoreProgramado: false,
				loadingStoreRealizado: false,

				modalProgramado: 'create',

				programado: {
					endoso: '',
					correlativo: '',
					fecha: '',
					monto: '',
					saldo: '',
					requerimiento: '',
					monto_neto: '',
					fecha_creacion: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					replicar: true,
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},

				},
				realizado: {
					endoso: '',
					cobro: '',
					fecha_pago: '',
					medio_pago: '',
					monto: '',
					factura: '',
					observaciones: '',
				},
				errors: {},
				compacta: false,
			}
		},

		methods: {
			getCobrosProgramados: function(){
				this.loadingCobrosProgramados = true;
				var url = 'api/polizas/'+this.codigo+'/cobros/programados';

				axios.get(url)
				.then(response => {
					this.cobros = response.data;
					$('#badge-cobros-programados').text(response.data.length);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loadingCobrosProgramados = false;
				});
			},

			addCobroProgramado: function(){
				this.cleanFieldsCobroProgramado();
				this.openModalCobroProgramado();
			},

			storeCobroProgramado: function(){
				this.loadingStoreProgramado = true;
				var url = 'api/cobros/programados';

				axios.post(url, {
					endoso: this.programado.endoso,
					fecha: this.programado.fecha,
					monto: this.programado.monto,
					saldo: this.programado.saldo,
					requerimiento: this.programado.requerimiento,
					monto_neto: this.programado.monto_neto
				})
				.then(response => {
					this.getCobrosProgramados();
					this.$toasted.show('El Cobro programado ha sido registrado.');
					this.closeModalCobroProgramado();
					var vm = this;
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al registrar Cobro Programado.');
				}).then(()=>{
					this.loadingStoreProgramado = false;
				});
			},

			reciboProvisional: function(cobro){
				var url = crm.route.polizas.reciboEndosoCobro+'?endoso='+cobro.CODIGO_DOCUMENTO+'&cobro='+cobro.CODIGO_COBRO
				window.open(url, '_blank');
			},

			showCobroProgramado: function(data){
				this.modalProgramado = 'show';
				this.programado.endoso = data.CODIGO_DOCUMENTO;
				this.programado.correlativo = data.CODIGO_COBRO;
				this.programado.fecha = data.FECHA_PROGRAMADO;
				this.programado.monto = data.MONTO_PROGRAMADO;
				this.programado.saldo = data.SALDO_COBRO;
				this.programado.requerimiento = data.REQUERIMIENTO;
				this.programado.monto_neto = data.MONTO_NETO;

				this.programado.fecha_creacion = data.FECHA_CREACION;
				this.programado.fecha_actualizacion = data.FECHA_ACTUALIZACION;
				this.programado.creado_desde = data.CREADO_DESDE;
				this.programado.actualizado_desde = data.ACTUALIZADO_DESDE;
				if (data.creado_por) {
					this.programado.creado_por.codigo = data.creado_por.CODIGO_USUARIO;
					this.programado.creado_por.nombre = data.creado_por.NOMBRE;
				}

				if (data.actualizado_por) {
					this.programado.actualizado_por.codigo = data.actualizado_por.CODIGO_USUARIO;
					this.programado.actualizado_por.nombre = data.actualizado_por.NOMBRE;
				}

				this.openModalCobroProgramado();
			},

			editCobroProgramado: function(data){
				this.modalProgramado = 'edit';
				this.programado.endoso = data.CODIGO_DOCUMENTO;
				this.programado.correlativo = data.CODIGO_COBRO;
				this.programado.fecha = data.FECHA_PROGRAMADO;
				this.programado.monto = data.MONTO_PROGRAMADO;
				this.programado.saldo = data.SALDO_COBRO;
				this.programado.requerimiento = data.REQUERIMIENTO;
				this.programado.monto_neto = data.MONTO_NETO;
				this.programado.replicar = true

				this.errors = {};

				this.openModalCobroProgramado();
			},

			updateCobroProgramado: function(){
				this.loadingStoreProgramado = true;
				this.errors = {};

				var url = 'api/endosos/'+this.programado.endoso+'/cobros/programados/'+this.programado.correlativo;

				axios.put(url, {
					fecha: this.programado.fecha,
					monto: this.programado.monto,
					saldo: this.programado.saldo,
					requerimiento: this.programado.requerimiento,
					monto_neto: this.programado.monto_neto,
					replicar: this.programado.replicar
				})
				.then(response => {
					this.getCobrosProgramados();
					this.$toasted.show('El Cobro programado ha sido actualizado.');
					this.closeModalCobroProgramado();
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar Cobro Programado.');
				}).then(()=>{
					this.loadingStoreProgramado = false;
				});
			},

			deleteCobroProgramado: function(data){
				var url = 'api/endosos/'+data.CODIGO_DOCUMENTO+'/cobros/programados/'+data.CODIGO_COBRO;
				var modules = this;

				$.confirm({
			        title: '¿Estás seguro?',
			        content: '¡Ya no podrás recuperar esta información!',
			        theme: 'supervan', // 'material', 'bootstrap'
			        buttons: {
			            Confirmar: function () {
			                axios.delete(url)
			                    .then(response => {
			                    	modules.getCobrosProgramados();
			                        modules.$toasted.show('Eliminado');
			                    })
			                    .catch(error => {
			                        modules.$toasted.show('Error al Eliminar');
			                        console.log(error);
			                        console.log(error.response);
			                    });
			            },
			            Cancelar: function () {
			            },
			        }
			    });
			},

			addCobroRealizado: function(data){
				this.realizado.endoso = data.CODIGO_DOCUMENTO;
				this.realizado.fecha_pago = moment().format('DD-MM-YYYY');
				this.realizado.cobro = data.CODIGO_COBRO;
				this.realizado.medio_pago = 11;
				this.realizado.monto = data.SALDO_COBRO;
				this.realizado.factura = data.REQUERIMIENTO;
				this.realizado.observaciones = '';

				this.errors = {};

				this.openModalCobroRealizado();
			},

			storeCobroRealizado: function(){
				var url = 'api/cobros/realizados';
				this.loadingStoreRealizado = true;
				this.errors = {};

				axios.post(url, {
					endoso: this.realizado.endoso,
					fecha_pago: this.realizado.fecha_pago,
					cobro: this.realizado.cobro,
					medio_pago: this.realizado.medio_pago,
					monto: this.realizado.monto,
					factura: this.realizado.factura,
					observaciones: this.realizado.observaciones,
				})
				.then(response => {
					this.getCobrosProgramados();
					this.$toasted.show('El Cobro ha sido realizado.');
					$('#modalCobroProgramadoEnviarRealizado').modal('hide');
					$('html').getCobrosRealizados();
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al registrar cobro realizado.');
				}).then(()=>{
					this.loadingStoreRealizado = false;
				});
			},

			openModalCobroProgramado: function(){
				$('#modalCobroProgramado').modal('show');
			},

			closeModalCobroProgramado: function(){
				$('#modalCobroProgramado').modal('hide');
			},

			openModalCobroRealizado: function(){
				$('#modalCobroProgramadoEnviarRealizado').modal('show');
			},

			closeModalCobroRealizado: function(){
				$('#modalCobroProgramadoEnviarRealizado').modal('hide');
			},

			cleanFieldsCobroProgramado: function(){
				this.modalProgramado = 'create';
				this.programado.endoso = '';
				this.programado.correlativo = '';
				this.programado.fecha = '';
				this.programado.monto = '';
				this.programado.saldo = '';
				this.programado.requerimiento = '';
				this.programado.monto_neto = '';
				this.programado.replicar = true

				this.errors = {};
			},

			validateFecha: function(date){
				var formato = 'DD/MM/YYYY';

				var hoy = moment();
				hoy = hoy.hour(0).minute(0).second(0).toISOString();

				var fecha = moment(date, "DD-MM-YYYY").toISOString();

				if (fecha <= hoy) {
					return true;
				}
				else {
					return false;
				}
			}
		},

		computed: {
            oportunidad: function () {
            	return JSON.parse(this.data);
            },

            codigoProducto: function(){
            	return this.producto;
            },

            total: function(){
            	return this.money(this.programado.sumaAsegurada - this.programado.deducible1 - this.programado.deducible2, true);
            },

            MontoProgramadoAcumulado: function(){
				let total = [];
				var $module = this;

				Object.entries(this.cobrosFiltered).forEach(([key, val]) => {
					total.push(val.MONTO_PROGRAMADO);
				});

				return this.money(total.reduce(function(total, num){
					return (parseFloat(total) || 0) + (parseFloat(num) || 0);
				}, 0), true);
			},

			MontoNetoAcumulado: function(){
				let total = [];
				var $module = this;

				Object.entries(this.cobrosFiltered).forEach(([key, val]) => {
					total.push(val.MONTO_NETO);
				});

				return this.money(total.reduce(function(total, num){
					return (parseFloat(total) || 0) + (parseFloat(num) || 0);
				}, 0), true);
			},

			SaldoAcumulado: function(){
				let total = [];
				var $module = this;

				Object.entries(this.cobrosFiltered).forEach(([key, val]) => {
					total.push(val.SALDO_COBRO);
				});

				return this.money(total.reduce(function(total, num){
					return (parseFloat(total) || 0) + (parseFloat(num) || 0);
				}, 0), true);
			},

			cobrosFiltered: function(){
				var val = this.filterEndoso;
				if (val != '') {
        			return this.cobros.filter(cobro => cobro.CODIGO_DOCUMENTO == val);
				}

				return this.cobros;
        	},

        	disabledValue: function(){
        		return this.disabled
        	}
        },

        watch: {
        	poliza: function(val){
        		if (val) {
        			this.codigo = val;
        			this.getCobrosProgramados();
        		}
        	},
  		}
	}
</script>